/**
 * VR — Volatility Ratio.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLVolatilidade.cs, classe
 * FML.VR — ≠ relativeVolatility do odin, fórmulas sem relação). Painel próprio,
 * 1 linha:
 *
 *   LC = REF(CLOSE, 1)
 *   VR = SUM(IF(C > LC, VOL, 0), N) / SUM(IF(C <= LC, VOL, 0), N) * 100
 *
 * Razão entre o volume das barras de alta e o das barras de baixa/estáveis na
 * janela. Paridade provada em __tests__/vr.silverlight.test.js.
 */
import { ref, gt, le, iff, sum, div, mul } from "./silverlightDsl";
import { VR as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const close = data.map((d) => num(d.close));
    // d.volume pode já ter sido processado pelo indicador Volume no mesmo
    // pipeline (applyIndicators roda em ordem): vira { volume, direction }.
    const vol = data.map((d) => {
      const raw = d.volume;
      return num(
        raw !== null && typeof raw === "object"
          ? Number(raw.volume)
          : Number(raw),
      );
    });

    const lc = ref(close, 1);
    const up = sum(iff(gt(close, lc), vol, 0), period);
    const dn = sum(iff(le(close, lc), vol, 0), period);
    const vr = mul(div(up, dn), 100);

    return vr.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // SUM(f,N) só emite a partir de i>N (janela de N+1 termos).
    return Math.max(0, period + 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
